<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slaccountbank}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountbank:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slaccountbank:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankNo" label="卡号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bank" label="所属银行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="branch" label="支行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="province" label="省" header-align="center" align="center"></el-table-column>
        <el-table-column prop="city" label="市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="area" label="区" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addIp" label="添加IP" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope == 0 ? '关闭' : '开启'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="picPath" label="银行对应图片URL" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankCode" label="银行编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cardType" label="卡类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cardAttribute" label="卡属性" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phoneNo" label="银行预留手机号（可能有别于注册手机号）" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cardId" label="钱包系统卡ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slaccountbank:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:slaccountbank:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slaccountbank-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slaccountbank/page',
        getDataListIsPage: true,
        exportURL: '/sys/slaccountbank/export',
        deleteURL: '/sys/slaccountbank',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
